export const LINKS = {
  PRIVACY: "سياسة الخصوصية",
  TERMS: "شروط الإستخدام",
  RIGHTS_RESERVED: "جميع الحقوق محفوظه © وفي",
};
